export default __webpack_public_path__ + "static/media/partner2.80c3dbcd.svg";